import React, { FC, ReactNode } from "react";

interface DocumentsContainer {
  children?: ReactNode;
}

export const DocumentsContainer: FC<DocumentsContainer> = ({
  children,
}): JSX.Element => (
  <div
    style={{
      width: "100%",
      paddingRight: 24,
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {children}
  </div>
);
